import React, { forwardRef } from 'react';
import { isElement } from 'react-is';
import CounterLabel from '../../CounterLabel/CounterLabel.js';
import { defaultSxProp } from '../../utils/defaultSxProp.js';
import classes from './UnderlineTabbedInterface.module.css.js';
import { clsx } from 'clsx';
import { BoxWithFallback } from './BoxWithFallback.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

// The gap between the list items. It is a constant because the gap is used to calculate the possible number of items that can fit in the container.
const GAP = 8;
const UnderlineWrapper = /*#__PURE__*/forwardRef(({
  children,
  className,
  sx: sxProp = defaultSxProp,
  ...rest
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement(BoxWithFallback, _extends({
    className: clsx(classes.UnderlineWrapper, className),
    ref: forwardedRef,
    sx: sxProp
  }, rest), children);
});
const UnderlineItemList = /*#__PURE__*/forwardRef(({
  children,
  ...rest
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: classes.UnderlineItemList,
    ref: forwardedRef
  }, rest), children);
});
const LoadingCounter = () => {
  return /*#__PURE__*/React.createElement("span", {
    className: classes.LoadingCounter
  });
};
LoadingCounter.displayName = "LoadingCounter"; // We can uncomment these when/if we add overflow behavior
// to the UnderlinePanels component
//
// export const StyledMoreButton = styled(Button)`
//   margin: 0;
//   border: 0;
//   background: transparent;
//   font-weight: normal;
//   box-shadow: none;
//   padding-block: var(--control-small-paddingBlock);
//   padding-inline: var(--control-small-paddingInline-condensed);
//   > span[data-component='trailingVisual'] {
//     margin-left: 0;
//   }
// `
// export const StyledOverflowDivider = styled.span`
//   display: inline-block;
//   border-left: 1px solid var(--borderColor-muted);
//   width: 1px;
//   margin-right: var(--control-xsmall-gap);
//   /* The height of the divider - reference from Figma */
//   height: 24px;
// `
// export const StyledMoreMenuListItem = styled.li`
//   display: flex;
//   align-items: center;
//   height: 45px;
// `
const UnderlineItem = /*#__PURE__*/forwardRef(({
  as = 'a',
  children,
  counter,
  icon: Icon,
  iconsVisible,
  loadingCounters,
  sx: sxProp = defaultSxProp,
  ...rest
}, forwardedRef) => {
  return /*#__PURE__*/React.createElement(BoxWithFallback, _extends({
    ref: forwardedRef,
    as: as,
    sx: sxProp,
    className: classes.UnderlineItem
  }, rest), iconsVisible && Icon && /*#__PURE__*/React.createElement("span", {
    "data-component": "icon"
  }, isElement(Icon) ? Icon : /*#__PURE__*/React.createElement(Icon, null)), children && /*#__PURE__*/React.createElement("span", {
    "data-component": "text",
    "data-content": children
  }, children), counter !== undefined ? loadingCounters ? /*#__PURE__*/React.createElement("span", {
    "data-component": "counter"
  }, /*#__PURE__*/React.createElement(LoadingCounter, null)) : /*#__PURE__*/React.createElement("span", {
    "data-component": "counter"
  }, /*#__PURE__*/React.createElement(CounterLabel, null, counter)) : null);
});

export { GAP, LoadingCounter, UnderlineItem, UnderlineItemList, UnderlineWrapper };
